module.exports = __webpack_public_path__ + "img/dice-five.6a36501d.svg";